export default
    {
        path:'/selfAssessment',
        name:'认识自我',
        redirect:'/selfAssessment/main',
        component:()=>import('../views/selfAssessment/index'),
        meta:{requireAuth:true,roles:['student']},
        children:[
            {
                path:'/selfAssessment/main',
                name:'认识自我主页',
                component:()=>import('../views/selfAssessment/main'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/adaptability',
                name:'生涯适应力测评',
                component:()=>import('../views/selfAssessment/adaptability/test_main.vue'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/test',
                name:'学业水平考试',
                component:()=>import('../views/selfAssessment/test'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/reward',
                name:'获奖页面',
                component:()=>import('../views/selfAssessment/reward'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/seniorOne',
                name:'高一',
                component:()=>import('../views/selfAssessment/seniorOne'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/seniorTwo',
                name:'高二',
                component:()=>import('../views/selfAssessment/seniorTwo'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/seniorThree',
                name:'高三',
                component:()=>import('../views/selfAssessment/seniorThree'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/message',
                name:'个人信息',
                component:()=>import('../views/selfAssessment/message'),
                meta:{requireAuth:true,roles:['student']},
            },
            {
                path:'/selfAssessment/diagnosis',
                name:'诊断主页面',
                component:()=>import('../views/selfAssessment/diagnosis/diagnosis.vue'),
                meta:{requireAuth:true,roles:['student']},
            }
        ]
    }
